/* eslint-disable */
// Lib
import { Action } from 'redux-actions';
import { put, takeEvery, select } from 'redux-saga/effects';

// Api
import {
  getUserCandidates as getUserCandidatesRequest,
  moveUserCandidate as moveUserCandidateRequest,
  rejectUserCandidate as rejectUserCandidateRequest,
  restoreUserCandidate as restoreUserCandidateRequest,
  deleteCandidate as deleteCandidateRequest,
  getUserStages as getUserStagesRequest,
} from 'api/candidates';

// Actions
import { getUserCandidates, setUserCandidates } from 'modules/Candidates/actions';
import {
  moveCandidateToStage,
  rejectUserCandidate,
  restoreRejectedCandidate,
  removeRecruiterCandidate,
  setJobBoardStages,
} from './actions';
import setLoading from 'actions/loading';
import { closeModal, setModalError } from 'actions/modal';

export function* getUserCandidatesSaga(action: Action<number>) {
  const { role, token } = yield select(state => state.user);

  try {
    const stages = yield getUserStagesRequest(role, action.payload, token);
    const candidates = yield getUserCandidatesRequest(role, action.payload, token);

    yield put(setJobBoardStages(stages.data));
    yield put(setUserCandidates(candidates.data));
  } catch (error) {
    console.error(error.response);
  }
}

function* moveUserCandidateSaga({ payload }: any) {
  const { jobId, stageId, stageTitle, candidateId } = payload;
  const { role, token } = yield select(state => state.user);

  try {
    if (stageTitle !== 'Placement') {
      yield moveUserCandidateRequest(role, { jobId, stageId, candidateId }, token);
    }
  } catch (error) {
    // fallback
    yield put(getUserCandidates(jobId));
    console.error(error.response);
  }
}

function* rejectUserCandidateSage({ payload }: any) {
  const { jobId, candidate, rejectReason } = payload;
  const { role, token } = yield select(state => state.user);

  try {
    yield rejectUserCandidateRequest(
      role,
      { jobId, candidateId: candidate.id, rejectReason },
      token
    );
  } catch (error) {
    // fallback
    yield put(getUserCandidates(jobId));
    console.error(error.response);
  }
}

function* restoreRejectedCandidateSaga({ payload }: any) {
  const { role, token } = yield select(state => state.user);

  try {
    yield restoreUserCandidateRequest(role, payload.id, token);
  } catch (error) {
    console.error(error.response);
  }
}

function* removeRecruiterCandidateSaga({ payload }: any) {
  const { token } = yield select(state => state.user);
  yield put(setLoading(true));
  try {
    yield deleteCandidateRequest(payload.id, token);
    yield put(closeModal());
  } catch (error) {
    yield put(setModalError({ error: error.response.data.error.message }));
    console.error(error.response.data.error.message);
  }
  yield put(setLoading(false));
}

export default function* jobBoardSagas() {
  yield takeEvery(getUserCandidates, getUserCandidatesSaga);
  yield takeEvery(moveCandidateToStage, moveUserCandidateSaga);
  yield takeEvery(rejectUserCandidate, rejectUserCandidateSage);
  yield takeEvery(restoreRejectedCandidate, restoreRejectedCandidateSaga);
  yield takeEvery(removeRecruiterCandidate, removeRecruiterCandidateSaga);
}
